/**
 * Homepage auto-send lands on /case-partner?draft=&q=. If selectedCase updates
 * to the destination matter after that URL is already in place, wiping
 * composing state makes the queued send bail.
 *
 * Only preserve for that destination update — not every selectedCase change
 * while draft/q remain in the URL.
 */
export function shouldPreserveCasePartnerComposing(
  search: string,
  selectedCase?: string | null,
  pathname?: string,
): boolean {
  const query = search.startsWith('?') ? search.slice(1) : search;
  if (!query) return false;
  const params = new URLSearchParams(query);
  if (!params.has('draft') && !params.has('q')) return false;
  if (!selectedCase) return false;
  const path = pathname ?? (typeof window === 'undefined' ? '' : window.location.pathname);
  const match = path.match(/\/matter\/([^/]+)/);
  return match?.[1] === selectedCase;
}
